import { SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useBookingRecoilValue } from "@/shared/client";
import { type Aside2DmaxInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Box, Center, Flex, Text } from "@chakra-ui/react";

export const Aside2Section = ({ data }: { data: Aside2DmaxInfoResponse }) => {
    const { MEDIAS } = useDesignMaxTheme();
    const bookingURL = useBookingRecoilValue();

    const { isMobile } = MEDIAS();
    const { imgList, sector } = { ...data };
    const onLink = (url: string) => {
        if (bookingURL.includes("http")) {
            window.open(url, "_blank");
        }
        if (!bookingURL.includes("http")) {
            window.open(`https://${url}`, "_blank");
        }
    };
    return (
        <Center w="100%" p={isMobile ? "0" : "100px 160px"}>
            <Center as="section">
                <Flex p={isMobile ? "56px 0" : "0 48px"} flexDir={isMobile ? "column" : "row"}>
                    <Box flex={isMobile ? "none" : "1"} position="relative" h={isMobile ? "296px" : "936px"}>
                        <Box
                            bottom="0"
                            left="0"
                            position="absolute"
                            maxW={isMobile ? "316px" : "656px"}
                            w="100%"
                            height={isMobile ? "256px" : "836px"}
                            background="#FBF6F2"
                            borderBottomLeftRadius={isMobile ? "40px" : "88px"}
                        />
                        <Center
                            zIndex="2"
                            top="0"
                            right="0"
                            maxW={isMobile ? "316px" : "656px"}
                            w="100%"
                            position="absolute"
                            height={isMobile ? "256px" : "836px"}
                            background={
                                imgList.length > 0 && imgList[0].img_URL
                                    ? `url(${imgList[0].img_URL})no-repeat center/cover`
                                    : "gray.100"
                            }
                            borderTopRightRadius={isMobile ? "40px" : "88px"}
                        >
                            {imgList.length <= 0 && <Text>등록된 이미지가 없습니다.</Text>}
                        </Center>
                    </Box>
                    <Flex flex={isMobile ? "none" : "1"} flexDir="column" gap={isMobile ? "0" : "251px"}>
                        <Box
                            p={isMobile ? "48px 24px 16px 24px" : "24px 80px"}
                            sx={{
                                "& p": {
                                    ...FONT("notoSerif", isMobile ? 24 : 54, isMobile ? 400 : 500, 1.4),
                                },
                            }}
                        >
                            <Text>{sector.main.firstLine}</Text>
                            <Text>{sector.main.secondLine}</Text>
                            <Text>{sector.main.thirdLine}</Text>
                            <Box
                                mt="32px"
                                sx={{
                                    "& p": {
                                        ...FONT("notoSerif", isMobile ? 14 : 20, 400, 1.4),
                                        color: "#a8a8a8",
                                    },
                                }}
                            >
                                <Text>{sector.sub.firstLine}</Text>
                                <Text>{sector.sub.secondLine}</Text>
                            </Box>
                        </Box>
                        <SpliteButton text="Reservation" onClick={() => onLink(bookingURL)} />
                    </Flex>
                </Flex>
            </Center>
        </Center>
    );
};
